import Answer from "./Answer";

export default interface Question {
  assessmentId: string;
  questionId: string;
  questionType: string;
  questionText: string;
  questionScenario: string;
  answers: Answer[];
  position: number;
  active: boolean;
  createdBy: string;
  status: string;
  incorrectPrompt: string;
  reviewerCompanyId: string;
  reviewerId: string;
  reviewers: QuestionReviewer[];
  promptResponseOnIncorrect: boolean;
  rootCompany: boolean;
}

export interface QuestionReviewer {
  employeeId: string;
  firstName: string;
  lastName: string;
  primaryEmailAddress: string;
}

export enum QuestionType {
  MultipleChoiceOne = "MULTIPLE_CHOICE_ONE_ANSWER",
  MultipleChoiceMulti = "MULTIPLE_CHOICE_MULTI_ANSWER",
  Essay = "ESSAY",
  TrueFalse = "TRUE_FALSE",
  WithResponse = "WITH_RESPONSE",
  WithResponseHr = "WITH_RESPONSE_HR"
}
